import { Pipe, PipeTransform } from '@angular/core';
import { DirectProperty, DirectPropertyCheck } from '@app/shared/services/properties/properties.service';

@Pipe({
  standalone: false,
  name: 'isPropertyGVREligible',
})
export class IsPropertyGVREligiblePipe implements PipeTransform {
  transform(property: DirectProperty): DirectPropertyCheck | null {
    if (!property?.checks) {
      return null;
    }

    const gvrCheck = property.checks.find((check) => check.id === 'google_vacation_rentals');

    return gvrCheck;
  }
}
